export default "/images/RxNT.jpg?ed6dff1174305be05ffd241a5f6bde88";